'use client';
/* eslint-disable tailwindcss/no-arbitrary-value */

import { useState, FC } from 'react';
import { FeLink } from '../../../components/FeLink';
import { PushDataLayerFn } from '../../../types/pushDataLayer';
import { useCmsClientContext } from '../../../utils/cmsPageContext';
import { NavigationItemLevel1 } from '../types';
import { navbarLinkToUrl } from '../utils/utils';
import SidebarGroup from './SidebarGroup';

interface SidebarSectionProps {
  pushDataLayer: PushDataLayerFn;
}

const SidebarSection: FC<SidebarSectionProps & NavigationItemLevel1> = (
  props,
) => {
  const { langPrefix, brand } = useCmsClientContext();
  const [isOpen, setIsOpen] = useState(false);
  const { sublinks = [], pushDataLayer, ...rest } = props;
  const { text, url_target, href } = navbarLinkToUrl(rest, {
    langPrefix,
    brand,
  });

  const toggleSection = () => {
    pushDataLayer({
      event: 'navigate',
      component_type: 'top-nav',
      component_title: `Level 2_${text}`,
      action: 'click',
      index: 0,
    });
    setIsOpen(!isOpen);
  };

  return (
    <div>
      {sublinks!.length === 0 ? (
        <div className="flex cursor-pointer items-center justify-between px-3 py-5">
          <FeLink
            href={href}
            target={url_target}
            className="font-semibold uppercase text-[#212529] text-[16px]"
            onClick={(e) => {
              e.stopPropagation();
              pushDataLayer({
                event: 'navigate',
                component_type: 'top-nav',
                component_title: `Level 1_${text}`,
                action: 'click',
                index: 0,
              });
            }}
          >
            {text}
          </FeLink>
        </div>
      ) : (
        // eslint-disable-next-line jsx-a11y/no-static-element-interactions
        <div
          onClick={toggleSection}
          className={`flex cursor-pointer items-center justify-between px-3 py-5 ${
            isOpen ? 'border-l-4 border-[#0081F1]' : ''
          }`}
        >
          <h2 className="font-semibold uppercase text-[#212529] text-[16px]">
            {text}
          </h2>
          <svg
            version="1.0"
            xmlns="http://www.w3.org/2000/svg"
            className={isOpen ? 'rotate-180' : 'rotate-0'}
            viewBox="0 0 320 512"
            width="12"
            height="12"
            aria-hidden="true"
          >
            <path d="M31.3 192h257.3c17.8 0 26.7 21.5 14.1 34.1L174.1 354.8c-7.8 7.8-20.5 7.8-28.3 0L17.2 226.1C4.6 213.5 13.5 192 31.3 192z" />
          </svg>
        </div>
      )}
      {isOpen && (
        <div>
          {sublinks!.map((sublink) => (
            <SidebarGroup
              key={`${sublink!.label}_${sublink!.url}`}
              pushDataLayer={pushDataLayer}
              {...sublink!}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default SidebarSection;
